import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'

export default class extends Controller {
  static targets = [ 'element' ]
  static values = { name: String }

  lastToggleTime = 0

  declare elementTarget: HTMLElement
  declare readonly nameValue: string
  declare readonly clickOutsideToggleValue: boolean


  connect() {
    useClickOutside(this, {
      element: this.elementTarget,
    })
  }

  toggle() {
    if (Date.now() - this.lastToggleTime < 100) {
      return
    }

    this.elementTarget.classList.toggle(this.nameValue)
    this.lastToggleTime = Date.now()
  }

  toggleFromOutside(event: Event) {
    if (Date.now() - this.lastToggleTime < 100) {
      return
    }

    if (!this.elementTarget.classList.contains(this.nameValue)) {
      this.elementTarget.classList.toggle(this.nameValue)
      this.lastToggleTime = Date.now()
    }
  }
}
